// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRelay = require("react-relay");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");

function makeRefetchVariables(after, first) {
  return {
          after: after,
          first: first
        };
}

var Types = {
  makeRefetchVariables: makeRefetchVariables
};

var variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

var responseConverter = {"__root":{"":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": 20,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v10 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
},
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "SHORT"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"SHORT\")"
  }
],
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "headline",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PriceRange",
    "kind": "LinkedField",
    "name": "priceRange",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Price",
        "kind": "LinkedField",
        "name": "maxPrice",
        "plural": false,
        "selections": (v11/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Price",
        "kind": "LinkedField",
        "name": "minPrice",
        "plural": false,
        "selections": (v11/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "PropertyImageConnection",
  "kind": "LinkedField",
  "name": "images",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PropertyImageEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageAttachment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "crop",
                  "value": true
                },
                {
                  "kind": "Literal",
                  "name": "embed",
                  "value": true
                },
                {
                  "kind": "Literal",
                  "name": "height",
                  "value": 324
                },
                (v10/*: any*/),
                {
                  "kind": "Literal",
                  "name": "width",
                  "value": 324
                }
              ],
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            (v4/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "propertyLocation",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPropertyLocation"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*: any*/)
      ],
      "type": "PropertyLocationWithHiddenAddress",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        }
      ],
      "type": "PropertyLocationWithVisibleAddress",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConversationsListRelayPaginationQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "FragmentSpread",
        "name": "ConversationsListRelay_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "ConversationsListRelayPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "QueryConversationV5Connection",
        "kind": "LinkedField",
        "name": "accountConversations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "QueryConversationV5Edge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ConversationV5",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ConversationMessageV5",
                    "kind": "LinkedField",
                    "name": "lastMessage",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sentAt",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "text",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationMessageFileConnection",
                        "kind": "LinkedField",
                        "name": "files",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationMessageImageConnection",
                        "kind": "LinkedField",
                        "name": "images",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "from",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*: any*/)
                            ],
                            "type": "Agent",
                            "abstractKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "unreadMessages",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "readState",
                        "value": "UNREAD"
                      }
                    ],
                    "concreteType": "ConversationMessagesConnection",
                    "kind": "LinkedField",
                    "name": "messages",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": "messages(readState:\"UNREAD\")"
                  },
                  {
                    "alias": "conversationListParticipants",
                    "args": (v8/*: any*/),
                    "concreteType": "ConversationParticipantConnection",
                    "kind": "LinkedField",
                    "name": "participants",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationParticipantEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v3/*: any*/),
                                  (v9/*: any*/),
                                  {
                                    "alias": "agentProfilePhoto",
                                    "args": null,
                                    "concreteType": "ProfilePhoto",
                                    "kind": "LinkedField",
                                    "name": "profilePhoto",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": [
                                          (v10/*: any*/),
                                          {
                                            "kind": "Literal",
                                            "name": "width",
                                            "value": 60
                                          }
                                        ],
                                        "kind": "ScalarField",
                                        "name": "url",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "membershipStatus",
                                    "storageKey": null
                                  }
                                ],
                                "type": "Agent",
                                "abstractKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "participants(first:20)"
                  },
                  {
                    "alias": "participantNames",
                    "args": (v8/*: any*/),
                    "concreteType": "ConversationParticipantConnection",
                    "kind": "LinkedField",
                    "name": "participants",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationParticipantEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v3/*: any*/),
                                  (v9/*: any*/)
                                ],
                                "type": "Agent",
                                "abstractKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "participants(first:20)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "conversationContext",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "entityType",
                            "storageKey": null
                          }
                        ],
                        "type": "RemovedConversationContext",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "context",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v12/*: any*/),
                                "type": "BuyerNeedV5",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v13/*: any*/),
                                  (v15/*: any*/)
                                ],
                                "type": "ForSalePropertyV5",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CategoryV5",
                                    "kind": "LinkedField",
                                    "name": "category",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "subject",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": "messageBroadcastStatus",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "status",
                                    "storageKey": null
                                  }
                                ],
                                "type": "MessageBroadcast",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v12/*: any*/),
                                "type": "RentalNeedV5",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v15/*: any*/),
                                  (v13/*: any*/)
                                ],
                                "type": "RentalPropertyV5",
                                "abstractKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "AvailableConversationContext",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "ConversationsListRelay_query_accountConversations",
        "kind": "LinkedHandle",
        "name": "accountConversations"
      }
    ]
  },
  "params": {
    "cacheID": "94d26c06eab00a045ceaea80d1f77ac5",
    "id": null,
    "metadata": {},
    "name": "ConversationsListRelayPaginationQuery",
    "operationKind": "query",
    "text": "query ConversationsListRelayPaginationQuery(\n  $after: String\n  $first: Int = 20\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  ...ConversationsListRelay_query_2HEEH6\n}\n\nfragment AgentProfilePhoto_agent on Agent {\n  displayName\n  agentProfilePhoto: profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n}\n\nfragment ConversationParticipantsDisplay_participantsConnection on ConversationParticipantConnection {\n  edges {\n    node {\n      __typename\n      ... on Agent {\n        id\n        displayName\n        ...AgentProfilePhoto_agent\n        membershipStatus\n      }\n      ... on AnonymousConversationParticipant {\n        __typename\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n  }\n}\n\nfragment ConversationsListItemContextLocationDisplay_location on PropertyLocation {\n  __isPropertyLocation: __typename\n  __typename\n  ... on PropertyLocationWithHiddenAddress {\n    locationDisplay\n  }\n  ... on PropertyLocationWithVisibleAddress {\n    locationDisplay\n    address\n  }\n}\n\nfragment ConversationsListItemContext_conversation on ConversationV5 {\n  conversationContext {\n    __typename\n    ... on RemovedConversationContext {\n      entityType\n    }\n    ... on AvailableConversationContext {\n      context {\n        __typename\n        ... on BuyerNeedV5 {\n          headline\n          priceRange {\n            maxPrice {\n              formatted(format: SHORT)\n            }\n            minPrice {\n              formatted(format: SHORT)\n            }\n          }\n        }\n        ... on ForSalePropertyV5 {\n          images {\n            edges {\n              node {\n                url(width: 324, embed: true, crop: true, height: 324, ratio: $__relay_internal__pv__DevicePixelRatio)\n                nodeId\n              }\n            }\n          }\n          propertyLocation {\n            __typename\n            ...ConversationsListItemContextLocationDisplay_location\n          }\n        }\n        ... on MessageBroadcast {\n          category {\n            name\n          }\n          subject\n          messageBroadcastStatus: status\n        }\n        ... on RentalNeedV5 {\n          headline\n          priceRange {\n            maxPrice {\n              formatted(format: SHORT)\n            }\n            minPrice {\n              formatted(format: SHORT)\n            }\n          }\n        }\n        ... on RentalPropertyV5 {\n          propertyLocation {\n            __typename\n            ...ConversationsListItemContextLocationDisplay_location\n          }\n          images {\n            edges {\n              node {\n                url(width: 324, embed: true, crop: true, height: 324, ratio: $__relay_internal__pv__DevicePixelRatio)\n                nodeId\n              }\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n  }\n}\n\nfragment ConversationsListItemParticipants_conversation on ConversationV5 {\n  conversationListParticipants: participants(first: 20) {\n    ...ConversationParticipantsDisplay_participantsConnection\n  }\n}\n\nfragment ConversationsListItem_conversation on ConversationV5 {\n  id\n  lastMessage {\n    ...ConversationsListItem_lastMessage\n    nodeId\n  }\n  unreadMessages: messages(readState: UNREAD) {\n    totalCount\n  }\n  ...ConversationsListItemParticipants_conversation\n  participantNames: participants(first: 20) {\n    edges {\n      node {\n        __typename\n        ... on Agent {\n          id\n          displayName\n        }\n        ... on AnonymousConversationParticipant {\n          __typename\n        }\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n  }\n  ...ConversationsListItemContext_conversation\n}\n\nfragment ConversationsListItem_lastMessage on ConversationMessageV5 {\n  sentAt\n  text\n  files {\n    totalCount\n  }\n  images {\n    totalCount\n  }\n  from {\n    __typename\n    ... on Agent {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      __typename\n      nodeId\n    }\n  }\n}\n\nfragment ConversationsListRelay_query_2HEEH6 on Query {\n  accountConversations(first: $first, after: $after) {\n    edges {\n      node {\n        id\n        lastMessage {\n          sentAt\n          nodeId\n        }\n        ...ConversationsListItem_conversation\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

var node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
              fetchKey: fetchKey,
              fetchPolicy: fetchPolicy,
              networkCacheConfig: networkCacheConfig
            });
}

function queryRefToObservable(token) {
  return Caml_option.nullable_to_opt(token.source);
}

function queryRefToPromise(token) {
  return new Promise((function (resolve, param) {
                var o = queryRefToObservable(token);
                if (o !== undefined) {
                  Caml_option.valFromOption(o).subscribe({
                        complete: (function () {
                            resolve({
                                  TAG: "Ok",
                                  _0: undefined
                                });
                          })
                      });
                  return ;
                } else {
                  return resolve({
                              TAG: "Error",
                              _0: undefined
                            });
                }
              }));
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
